module.exports = __webpack_public_path__ + "static/media/AAM-squares.fe262d24.svg";